import { render, staticRenderFns } from "./AddCampaignKeywordModal.vue?vue&type=template&id=8a845f84"
import script from "./AddCampaignKeywordModal.vue?vue&type=script&lang=js"
export * from "./AddCampaignKeywordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports